import React from 'react';
import Accordian from '../../../atoms/Accordian/Accordian';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
const PrivacyQuestions = props => {
  const { questionList = [] } = props;
  const onClickHandler = e => {
    const accordian = e.target.parentElement.parentElement.parentElement;
    accordian.classList.contains('privacy-accordian-open')
      ? accordian.classList.remove('privacy-accordian-open')
      : accordian.classList.add('privacy-accordian-open');
  };
  return (
    <div>
      {questionList.map(item => {
        // console.log("item",questionList)
        return (
          <div className='privacy-accordian'>
            <Accordian header={item.question} onClickHandler={onClickHandler}>
              <div
                dangerouslySetInnerHTML={{
                  __html: documentToHtmlString(item.answer),
                }}
                className='privacy-accordian-answer'
              />
            </Accordian>
          </div>
        );
      })}
    </div>
  );
};

export default PrivacyQuestions;
